import e from "./_baseCreate.js";
import r from "./extendOwn.js";
function t(t, a) {
  var o = e(t);
  return a && r(o, a), o;
}
export { t as default };